export default __webpack_public_path__ + "static/media/Logo_Pepper_2022.eb999846.svg";